import useMountEffect from '@restart/hooks/useMountEffect';
import { RiExternalLinkLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

const Panel = ({ data: [robot] }) => {
  useMountEffect(() => {
    window.open(`http://119.197.203.104:32080/?id=${robot.id}`);
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'QSS';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiExternalLinkLine;
Command.Panel = Panel;

export default Command;
